import { curry } from 'fxjs/es';

/**
 * @param {string} str
 * @return {boolean} is normal string (not Infinity, NaN, some weird string)
 */
export const isNormalNumberString = (str) => {
  if (str === '') {
    return false; // It is not a normal number string
  }

  // Check if the string is a valid number and not NaN
  if (!isNaN(+str)) {
    // Check if the number is finite and not Infinity or -Infinity
    if (isFinite(+str)) {
      return true; // It is a normal number string
    }
  }
  return false; // It is not a normal number string
};

export const isNumber = (value) => {
  return typeof value === 'number' && isFinite(value);
};

// integer 만 사용 가능
export const addZeroInteger = curry((digit, number) => {
  const zero_count = digit - number.toString().length;
  return Array.from({ length: zero_count }).fill('0').join('') + number;
});
